module.exports = __webpack_public_path__ + "static/img/couse01.5ed8c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/couse01.jpg
// module id = UhaN
// module chunks = 1